import React from 'react';
import styles from './styles.module.scss';
import {Link} from 'react-router-dom';
import {APP_PATHS} from '../../../constants';

const AuthTerms: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      By signing in, you agree to our{' '}
      <Link className={styles.link} to={APP_PATHS.TERMS}>
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link className={styles.link} to={APP_PATHS.PRIVACY}>
        Privacy Policy
      </Link>
      .
    </div>
  );
};

export default AuthTerms;
